import type { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import * as stripeApi from '@/services/stripeService';
import * as hubspotAccountCreation from '@/services/hubspotAccountCreationService';
import * as actions from '../user/userActions';

export function* stripeSuccessSubscriptionSaga({ payload }: any): SagaIterator {
	try {
		const {
			data: { accessToken, refreshToken, user }
		} = yield call(stripeApi.stripeSuccessSubscription, payload);

		if (!accessToken || !refreshToken) {
			throw new Error('No access token or refresh token');
		}
		yield put(
			actions.loginUserSuccess({
				accessToken,
				refreshToken,
				name: user.name,
				role: user.role,
				company: user.company,
				email: user.email,
				login_count: 1
			})
		);
	} catch (error) {
		console.log('Error: ', error);
	}
}

export function* hubspotPretrialSaga({ payload }: any): SagaIterator {
	try {
		const {
			data: {data: { accessToken, refreshToken, user }}
		} = yield call(hubspotAccountCreation.hubspotPretrialFirstLogin, payload.signupSessionId, payload.email);

		if (!accessToken || !refreshToken) {
			throw new Error('No access token or refresh token');
		}
		yield put(
			actions.loginUserSuccess({
				accessToken,
				refreshToken,
				name: user.name,
				role: user.role,
				company: user.company,
				email: user.email,
				login_count: 1
			})
		);
	} catch (error) {
		console.log('Error: ', error);
	}
}
